import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import {
  GiftItemData,
  GiftItemForStore,
  GiftItemListData,
  GiftItemListForStore,
} from './giftItem.interface';

// 목록 조회
export const giftItemListStatusAtom = atom<QueryStatus>({
  key: 'giftItemListStatusAtom',
  default: 'idle',
});

export const giftItemListDataAtom = atom<GiftItemListData | null>({
  key: 'giftItemListDataAtom',
  default: null,
});

// 단건 조회
export const giftItemStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftItemStatusAtomFamily',
  default: 'idle',
});

export const giftItemDataAtomFamily = atomFamily<GiftItemData | null, string>({
  key: 'giftItemDataAtomFamily',
  default: null,
});

// Store용 목록 (bugoId 기반)
export const giftItemListForStoreStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftItemListForStoreStatusAtomFamily',
  default: 'idle',
});

export const giftItemListForStoreDataAtomFamily = atomFamily<
  GiftItemListForStore | null,
  string
>({
  key: 'giftItemListForStoreDataAtomFamily',
  default: null,
});

// Store용 단건 조회
export const giftItemForStoreStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftItemForStoreStatusAtomFamily',
  default: 'idle',
});

export const giftItemForStoreDataAtomFamily = atomFamily<GiftItemForStore | null, string>(
  {
    key: 'giftItemForStoreDataAtomFamily',
    default: null,
  },
);
